import React, { useState, useEffect, Fragment } from "react";

const useTableWorkPrimise = (
  workPrimiseData,
  handleDelWorkPrimsie,
  handleEditClick,
  onClickToggleFromTable
) => {
  const [thead] = useState(["Work Premise", "Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
    // let trowArr = [];
    let trowArr = workPrimiseData.map((el) => {
      return {
        "Work Premise": el.workingPremiseType,
        Action: (
          <Fragment>
             <i
              className="fas fa-edit ml-4"
              style={{ marginRight: "10px", cursor: "pointer" }}
              onClick={() => {
                handleEditClick(el, el.workingPremiseId);
                onClickToggleFromTable();
              }}
            ></i>
            <i
              className="fas fa-trash"
              onClick={() => handleDelWorkPrimsie(el.workingPremiseId)}
            ></i>
           
          </Fragment>
        ),
      };
    });

    setTrow(trowArr);
  }, [
    workPrimiseData,
    handleDelWorkPrimsie,
    handleEditClick,
    onClickToggleFromTable,
  ]);

  // setTrow(trowArr);

  return { thead, trow };
};

export default useTableWorkPrimise;
